import {Button, message, Modal, Popconfirm, Select, Spin, Tooltip} from 'antd'
import React from 'react'
import { CustomRow, CustomCol } from '../../components/Custom';
import DetailTitle from '../../components/DetailTitle';
import FileUpload_JR from '../../components/FileUpload_JR';

import { Row,Col,Form, Input, InputNumber } from "antd";
import {
} from '../../axios/dictionaries';
import {config, post, postFrom} from '../../axios';
import {
    API_CHECKLIST,
    API_device_findList, API_HOUSEDEVICEINVENTORYBYID,
    API_salesroom_findList
} from '../../axios/config';
import Choose from "./Choose";
import AuthButton from "../../components/AuthButton/AuthButton";

class DeviceDetail extends React.Component{
  state = {
    id: null,
      checkRoomInId:null,
    visible: false,
    dataInfo: {},
    salesroomList: [],
      deviceList:[],
    dataLoading: false,
    submitLoading: false,
    data: {
        houseLayout: [],
        deviceNodeList:[],
    }
  }
  open(id = null) {
    if (id) {
      this.postHouseTypeGet(id)
    }
    this.postDeviceList();
    this.postSalesroomList()
    this.setState({ visible: true, id })
    return new Promise((resolve,reject) => {
      this.monitor = { resolve, reject }
    })
  }
  close() {
    this.setState({ visible: false ,data: {}})
    this.props.form.resetFields()
  }
  renderFooter() {
    return (
      <div className="app-modal-footer">
        <Button onClick={this.close.bind(this)}>取消</Button>
      </div>
    )
  }
  postSalesroomList() {
    post({ url: API_salesroom_findList }).then(res =>{
      this.setState({ salesroomList: res })
    })
  }
    postDeviceList() {
        post({ url: API_device_findList }).then(res =>{
            this.setState({ deviceList: res })
        })
    }
  postHouseTypeSubmit(data) {
    const url =  API_CHECKLIST+ '?houseId=' + this.state.id
    this.setState({ submitLoading: true })

    return post({ url, data }).then(res => {
       // this.setState({ submitLoading: false })
    }).finally(err => {
      this.setState({ submitLoading: false })
    })
  }
  postHouseTypeGet(id) {
    this.setState({ dataLoading: true })
    post({ url: API_HOUSEDEVICEINVENTORYBYID + '?houseId=' + id  }).then(res => {
      const data = {
          houseId: res.houseId,
          buildingName: res.buildingName,
          merchantName: res.merchantName,
          shortName: res.shortName,
          projectName: res.projectName,
          operationStartDate: res.operationStartDate,
          operationEndDate: res.operationEndDate,
          totalRent: res.totalRent,
          ccbProjectName: res.ccbProjectName,
          roomTypeName: res.roomTypeName

      }
      res.checkRoomInId = res.checkRoomInId;
        res.houseLayout = res.deviceVoList.map((item, index) => { //添加一个key，以便增加一栏时数据不错乱
            item.key = index;
            item.f= item.categoryName;
            item.t= item.deviceCategory;
            item.i= item.deviceModel;
            item.j= item.rent;
            return item
        });

        res.deviceNodeList = res.deviceNodeList.map((item, index) => { //添加一个key，以便增加一栏时数据不错乱
            item.key = index;
            item.f= item.notes;
            item.t= item.merchantUserName;
            item.i= item.createTime;
            return item
        });

      this.props.form.setFieldsValue(data)
      this.setState({ data: res,dataLoading: false })
    }).catch(err => {
      this.setState({ dataLoading: false });
    })
  }
  handleSubmit() {
    this.props.form.validateFields((err, values) => {
      if (err) return
      values.id = this.state.id || undefined

      //根据房源Id提交核对清单


      this.postHouseTypeSubmit(values).then(() => {
        this.close()
        this.monitor.resolve()
        message.success('保存成功')
      }).catch((e) => {
        message.error(e.message)
      })
    })
  }
  render(){
    const modalConfig = {
      title: '房源设备清单',
      visible: this.state.visible,
      footer: this.renderFooter(),
      width: 1200,
      onCancel: () => this.close()
    }
  let {
      data,
  } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form
    const labelWidth = 70
    const labelValue = getFieldValue('label')
    return (
      <Modal {...modalConfig}>
        <Spin spinning={this.state.dataLoading}>
          <div className="custom" style={{padding: 20}}>
            <Form  labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
              <Row>
                <Col span={24}>
                  <DetailTitle title="基本信息" boxStyle={{ marginTop: '0' }} />
                  <CustomRow >

                    <CustomCol labelStyle={{ width: labelWidth }} label="商户名称">
                        {getFieldDecorator('merchantName', {
                            rules: [{ required: true, message: '请输入户型名称', }],
                        })(
                            <Input
                                placeholder={'请输入'}
                                autoComplete={'off'}
                            />
                        )}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} label="项目名称">
                        {getFieldDecorator('projectName', {
                            rules: [{
                                required: true, message: '请选择所属门店',
                            }],
                        })(
                          <Input
                            placeholder={'请输入'}
                            autoComplete={'off'}
                            />
                        )}
                    </CustomCol>
                      <CustomCol labelStyle={{ width: labelWidth }} label="楼栋名称">
                          {getFieldDecorator('buildingName', {
                              rules: [{ required: true, message: '请输入户型名称', }],
                          })(
                              <Input
                                  placeholder={'请输入'}
                                  autoComplete={'off'}
                              />
                          )}
                      </CustomCol>
                  </CustomRow>

                    <CustomRow divider>

                        <CustomCol labelStyle={{ width: labelWidth }} label="门店名称">
                            {getFieldDecorator('ccbProjectName', {
                                rules: [{
                                    required: true, message: '请选择所属门店',
                                }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                        <CustomCol labelStyle={{ width: labelWidth }} label="户型名称">
                            {getFieldDecorator('roomTypeName', {
                                rules: [{ required: true, message: '请输入户型名称', }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                        <CustomCol labelStyle={{ width: labelWidth }} label="总租金">
                            {getFieldDecorator('totalRent', {
                                rules: [{
                                    required: true, message: '请选择所属门店',
                                }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>


                        <CustomCol labelStyle={{ width: labelWidth }} label="运营开始日期">
                            {getFieldDecorator('operationStartDate', {
                                rules: [{ required: true, message: '请输入户型名称', }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                        <CustomCol labelStyle={{ width: labelWidth }} label="运营结束日期">
                            {getFieldDecorator('operationEndDate', {
                                rules: [{
                                    required: true, message: '请选择所属门店',
                                }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>




                    <DetailTitle title="设备列表"  />
                    {
                        data.houseLayout instanceof Array
                            ? data.houseLayout.map((item, index) => {
                                return <CustomRow key={item.key}>
                                    <CustomCol labelStyle={{ width: labelWidth }} label="户型品类">
                                        {getFieldDecorator(`f${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.f
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol labelStyle={{ width: labelWidth }} label="设备品类">
                                        {getFieldDecorator(`t${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.t
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol labelStyle={{ width: labelWidth }} label="设备型号">
                                        {getFieldDecorator(`i${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.i
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol labelStyle={{ width: labelWidth }} label="设备租金">
                                        {getFieldDecorator(`j${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.j
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                            })
                            : null

                    }
                    <DetailTitle title="设备备注列表"  />
                    {
                        data.deviceNodeList instanceof Array
                            ? data.deviceNodeList.map((item, index) => {
                                return <CustomRow key={item.key}>
                                    <CustomCol labelStyle={{ width: '340px' }} label="备注信息">
                                        {getFieldDecorator(`f${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.f
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol labelStyle={{ width: labelWidth }} label="操作人">
                                        {getFieldDecorator(`t${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.t
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol labelStyle={{ width: labelWidth }} label="操作时间">
                                        {getFieldDecorator(`i${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.i
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                            })
                            : null

                    }
                </Col>
              </Row>
            </Form>
          </div>
        </Spin>
          <div style={{position: "absolute", bottom: "16px", left: "16px"}}>
              <AuthButton authkey="z-1-6" type="primary" icon="export">
                <span className="showClickDetail" style={{textDecoration: "underline"}} onClick={this.handleChoose.bind()} >添加设备备注</span>
              </AuthButton>
          </div>
          <Choose
              onRef={ref => this.chooseRef = ref}
          />
      </Modal>
    )

  }
  handleMinus = (index) => { //房源户型减1
        let { data } = this.state;
        let item = data.houseLayout[index];
        if (item) {
            if (item.id) {
                this.setState({ loading: true });
                postFrom({ url: config.API_category_device_deleteDeviceLayout, data: { houseLayoutId: item.id } }).then(res => {
                    data.houseLayout.splice(index, 1);
                    this.setState({ data, loading: false });
                }).catch(err => {
                    message.error(err.message || '删除失败');
                    this.setState({ loading: false })
                });
            } else {
                data.houseLayout.splice(index, 1);
                this.setState({ data });
            }
        }
    }

    handlePlus = () => { //房源户型加1
        let { data } = this.state;
        if (data.houseLayout instanceof Array) {
            if (data.houseLayout.length) {
                data.houseLayout.push({ key: data.houseLayout[data.houseLayout.length - 1].key + 1, f: '', t: '', });
            } else {
                data.houseLayout.push({ key: 0, f: '', t: '' });
            }
        } else {
            data.houseLayout = [{ key: 0, f: '', t: '' }];
        }
        this.setState({ data });
    }
    handleChoose = () => {
        if (this.chooseRef) {
            this.chooseRef.onShow(this.state.data.checkRoomInId).then(res => {
                console.log('222');
                this.postHouseTypeGet(this.state.id);
            }).catch(() => {})
        }
    }
    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({ data: {}, loading: false, title: "新增小区/楼栋" });
    }
}



export default Form.create({ wrappedComponentRef: true })(DeviceDetail)


// WEBPACK FOOTER //
// ./src/page/OperateHouse/deviceDetail.jsx